import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { c as l } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const p = ({
  htmlFor: e,
  required: r,
  children: t,
  className: s,
  ...o
}) => /* @__PURE__ */ a(
  "label",
  {
    htmlFor: e,
    className: l(
      "block text-sm font-medium leading-snug tracking-[0.01em] text-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      s
    ),
    ...o,
    children: [
      t,
      r && /* @__PURE__ */ i("span", { className: "ms-1 text-destructive", children: "*" })
    ]
  }
);
export {
  p as L
};
